import { Component, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import JoinButtons from "@/components/JoinButtons";
import EarningSection from "@/components/EarningSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import WhyRecommendSection from "@/components/WhyRecommendSection";
import CTAStackSection from "@/components/CTAStackSection";
import Footer from "@/components/Footer";

class ErrorBoundary extends Component {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="grid min-h-screen place-items-center p-8 text-center">
          <p className="font-display text-xl font-bold text-[#1a237e]">
            Something went wrong. Please refresh the page.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

const Home = () => (
  <div id="top" className="min-h-screen overflow-x-clip bg-white antialiased">
    <Header />
    <main>
      <HeroSection />
      <JoinButtons />
      <EarningSection />
      <HowItWorksSection />
      <WhyRecommendSection />
      <CTAStackSection />
    </main>
    <Footer />
  </div>
);

function App() {
  useEffect(() => {
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    let lenis = null;
    if (!prefersReduced) {
      lenis = new Lenis({ duration: 1.15, smoothWheel: true });
      window.__lenis = lenis;
      let raf;
      const loop = (time) => {
        lenis.raf(time);
        raf = requestAnimationFrame(loop);
      };
      raf = requestAnimationFrame(loop);
    }
    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const hash = anchor.getAttribute("href");
      if (hash === "#" || hash === "#top") {
        e.preventDefault();
        if (window.__lenis) window.__lenis.scrollTo(0);
        else window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }
      const el = document.querySelector(hash);
      if (el) {
        e.preventDefault();
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -84 });
        else el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      document.removeEventListener("click", onClick);
      if (lenis) lenis.destroy();
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;